import { editAssessmentBreadcrumbs } from '@constants/breadcrumbItems';
import useFetchSingleChallenge from '@pages/challengeGroups/challenge/_hooks/useFetchSingleChallenge';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import DataCheck from 'lib/src/components/common/DataCheck';
import Description from 'lib/src/components/typography/Description';
import Title from 'lib/src/components/typography/Title';
import { isEmpty } from 'lib/src/utils/generic';
import { useParams } from 'react-router';

import EditOrganisationForm from './EditOrganisationForm';
import useFetchOrganisation from './hooks/useFetchOrganisation';
import useFetchSubmission from './hooks/useFetchSubmission';

interface Params {
    id: string;
}

const EditOrganisation = () => {
    const { id } = useParams<Params>();

    const { organisation, isFetching, fetchError } = useFetchOrganisation(parseInt(id));

    const { submission } = useFetchSubmission(parseInt(id));

    const { challenge: assessmentChallenge } = useFetchSingleChallenge(submission.challengeID);

    editAssessmentBreadcrumbs[2].name = organisation == null ? 'Loading' : assessmentChallenge.name;
    editAssessmentBreadcrumbs[2].link = `/assessments/edit-application/${
        organisation?.submissionId || ''
    }`;

    return (
        <DataCheck dataExists={!isEmpty(organisation)} isFetching={isFetching} error={fetchError}>
            <>
                <Breadcrumb items={editAssessmentBreadcrumbs} />
                <Title>
                    Edit Dynamic fall arrest system for offshore technician transfers application
                </Title>
                <Description>Edit the details of this challenge entry.</Description>

                <EditOrganisationForm organisation={organisation} />
            </>
        </DataCheck>
    );
};

export default EditOrganisation;
